// extracted by mini-css-extract-plugin
export default {"container":"logline_container__vD+4I","logline":"logline_logline__B0oAw","img":"logline_img__vRBaq"};